import CoopService from "./services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    working: false,
    loadingDetails: false,
    loadingRecords: false,
    processingRecord: false,
    details: {},
    records: [],
    IOrganisationsMemberShips : {},
  },
  getters: {
    working(state) {
      return state.working;
    },
    loadingDetails(state) {
      return state.loadingDetails;
    },
    details(state) {
      return state.details;
    },
    records(state) {
      return state.records;
    },
    loadingRecords(state) {
      return state.loadingRecords;
    },
    processingRecord(state) {
      return state.processingRecord;
    },
    IOrganisationsMemberShips(state) {
      return state.IOrganisationsMemberShips;
    },
  },
  mutations: {
    setWorking(state, val) {
      state.working = val;
    },
    setLoadingDetails(state, val) {
      state.loadingDetails = val;
    },
    setIOrganisationsMemberShips(state, val) {
      console.log('val' , val)
      state.IOrganisationsMemberShips = val;
    },
    setLoadingRecords(state, val) {
      state.loadingRecords = val;
    },
    setProcessingRecords(state, val) {
      state.processingRecords = val;
    },
    setDetails(state, val) {
      state.details = val;
    },
    setRecords(state, val) {
      state.records = val;
    },
  },
  actions: {
    async updateMainInfo({ commit }, { form, id }) {
      commit("setWorking", true);
      try {
        await CoopService.updateMainInfo({ form, id });
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async addNewRecord({ commit }, { form, endpoint }) {
      commit("setWorking", true);
      try {
        const res = await CoopService.addnewRecord({ form, endpoint });
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async updateRecord({ commit }, { form, endpoint }) {
      commit("setWorking", true);
      try {
        const res = await CoopService.updateRecord({ form, endpoint });
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteRecord({ commit }, endpoint) {
      commit("setWorking", true);
      try {
        const res = await CoopService.deleteRecord(endpoint);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async fetchRecords({ commit }, ep) {
      commit("setLoadingRecords", true);
      try {
        var records = await CoopService.getRecords(ep);
        commit("setRecords", records.data);
      } catch (err) {
      } finally {
        commit("setLoadingRecords", false);
      }
    },

    async addProject({ commit }, form) {
      commit("setWorking", true);
      try {
        await CoopService.storeProject(form);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteProject({ commit }, id) {
      commit("setWorking", true);
      try {
        await CoopService.deleteProject(id);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async fetchProjectDetails({ commit }, id) {
      commit("setLoadingDetails", true);
      try {
        var details = await CoopService.getProjectById(id);
        commit("setDetails", details.data);
      } catch (err) {
      } finally {
        commit("setLoadingDetails", false);
      }
    },
    
    
    async fetchIOrganisationsMemberShips({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await CoopService.fetchIOrganisationsMemberShips(payload);
        if (hasError(res.status)) throw res;
        
        commit("setIOrganisationsMemberShips", res.data);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
